import { S } from '../app/app_state.js?v=20260817c';
import { AppRuntime } from '../app/app_runtime.js?v=20260706d';
import { escapeHtml } from '../utils/html_utils.js?v=20260706d';
import { getCoreObjects } from '../objects/object_service.js?v=20260706d';
import * as SystemRegistry from '../registry/system_registry.js?v=20260904f';

function sidebarObjectMeta(object) {
  return object?.sidebarMeta || object?.metaLabel || object?.detailLabel || object?.productLabel || '';
}

function currentListContext(element) {
  const project = S.project, sheetId = S.drawingSheets?.activeSheetId;
  return () => element.isConnected !== false && project === S.project && sheetId === S.drawingSheets?.activeSheetId;
}

function bindSidebarObjectActivation(element, object) {
  const current = currentListContext(element);
  const activate = event => {
    if (!current() || event.target?.closest?.('button')) return false;
    const systemId = object?.systemId || object?.systemKey || '';
    const system = SystemRegistry.getSystem(systemId);
    if (!system || typeof system.selectCoreObject !== 'function') return false;
    SystemRegistry.activateSystem(systemId);
    if (SystemRegistry.selectCoreObject(systemId, object, { event }) !== true) return false;
    AppRuntime.refresh(false);
    return true;
  };

  element.addEventListener('click', activate);
  element.addEventListener('keydown', event => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    activate(event);
  });
}

function bindSidebarObjectVisibility(button, object) {
  const current = currentListContext(button);
  button.addEventListener('click', event => {
    event.preventDefault();
    event.stopPropagation();
    if (!current()) return;
    const nextVisible = object.visible === false;
    const systemId = object?.systemId || object?.systemKey || '';
    if (SystemRegistry.setCoreObjectVisibility(systemId, object, nextVisible, { event }) !== true) return;
    AppRuntime.refresh(false);
  });
}

function renderSummaryRow(row) {
  const element = document.createElement('div');
  element.className = `group-item object-list-row${row.active ? ' active' : ''}${row.visibility === 'hidden' ? ' is-muted' : ''}`;
  element.dataset.sidebarRowId = row.id;
  element.dataset.sidebarSystemId = row.systemId;
  const select = document.createElement('button');
  select.type = 'button'; select.className = 'object-item-main';
  select.textContent = `${row.displayName} · ${row.count}`;
  select.setAttribute('aria-label', `${row.displayName}: ${row.count}`);
  element.appendChild(select);
  if (row.sidebarMeta) {
    const detail = document.createElement('span'); detail.className = 'small-text';
    detail.textContent = row.sidebarMeta; select.appendChild(detail);
  }
  const visibility = document.createElement('button');
  visibility.type = 'button'; visibility.className = 'object-visibility-toggle';
  visibility.dataset.visibility = row.visibility;
  visibility.textContent = row.visibility === 'mixed' ? 'Teilweise' : row.visibility === 'visible' ? 'Ein' : 'Aus';
  visibility.setAttribute('aria-label', `${row.displayName}: Sichtbarkeit`);
  visibility.setAttribute('aria-pressed', row.visibility === 'mixed' ? 'mixed' : String(row.visibility === 'visible'));
  visibility.title = row.visibility === 'mixed' ? 'Alle Mitglieder einblenden' : 'Mitglieder ein- oder ausblenden';
  element.appendChild(visibility);
  const current = currentListContext(element);
  select.addEventListener('click', () => {
    if (!current()) return;
    SystemRegistry.activateSystem(row.systemId);
    if (SystemRegistry.selectSidebarRow(row.systemId, row.id)) AppRuntime.refresh(false);
  });
  visibility.addEventListener('click', event => {
    event.stopPropagation();
    if (!current()) return;
    if (SystemRegistry.setSidebarRowVisibility(row.systemId, row.id, row.visibility !== 'visible')) AppRuntime.refresh(false);
  });
  return element;
}

function renderObjectList() {
  const section = document.getElementById('objectListSection');
  const host = document.getElementById('objectList');
  if (!host) return false;
  host.innerHTML = '';
  let itemCount = 0;

  for (const object of getCoreObjects()) {
    const element = document.createElement('div');
    element.className = `group-item object-list-row${object.active ? ' active' : ''}${object.visible === false ? ' is-muted' : ''}`;
    element.tabIndex = 0;
    element.setAttribute('role', 'button');
    element.dataset.sidebarObjectKey = object.key || '';
    element.dataset.sidebarObjectId = object.objectId || object.id || '';
    element.dataset.sidebarSystemId = object.systemId || object.systemKey || '';

    const meta = sidebarObjectMeta(object);
    element.innerHTML = `
      <div class="object-item-main">
        <div><strong>${escapeHtml(object.displayName)}</strong></div>
        ${meta ? `<div class="small-text">${escapeHtml(meta)}</div>` : ''}
      </div>
      <button type="button" class="object-visibility-toggle" data-object-visibility-toggle title="Objekt ein- oder ausblenden">${object.visible === false ? 'Aus' : 'Ein'}</button>
    `;

    bindSidebarObjectActivation(element, object);
    const visibilityButton = element.querySelector('[data-object-visibility-toggle]');
    if (visibilityButton) bindSidebarObjectVisibility(visibilityButton, object);
    host.appendChild(element);
    itemCount += 1;
  }

  for (const row of SystemRegistry.collectSidebarRows()) {
    host.appendChild(renderSummaryRow(row)); itemCount += 1;
  }
  if (section) section.hidden = itemCount <= 0;
  return itemCount > 0;
}

export {
  renderObjectList
};
